function onSearch() {
  const $searchInput = $('#searchInput');
  const $submitButton = $('#searchForm button[type="submit"]');

  $submitButton.prop('disabled', true);

  $('#searchToggle, #searchToggleMobile').on('click', function (event) {
    event.preventDefault();
    $('#searchForm').slideToggle(300);
  });

  $('#closeSearch').on('click', function () {
    $('#searchForm').slideUp(300);
    $searchInput.val('').trigger('input');
  });

  $searchInput.on('input', function () {
    const inputVal = $(this).val().trim();
    $submitButton.prop('disabled', inputVal === '');
  });
}

function onResults() {
  $('.search-results__grid').find('.col, .col--1-4, .col--1-3, .card-no-bg').removeClass('col col--1-4 col--1-3 card-no-bg');

  const $sections = $('section.search-results__programmes, section.search-results__prospectus, section.search-results__news-event');
  if ($sections.children().length === 0) {
    $sections.append('<div class="no-search-result"><h3>No search results found.</h3></div>');
    $('.search-results .search-results-container').append('<div class="no-search-results"><h3>No search results found.</h3></div>');
  }

  const activeTab = $('.searchtab.active').attr('id');
  if (activeTab) {
    $('body').removeClass(function (index, className) {
      return (className.match(/(^|\s)tab-\S+/g) || []).join(' ');
    });
    $('body').addClass(`tab-${activeTab}`);
  }
}

export { onSearch, onResults };


